<template>
    <div class="pagination" v-if="totalPages > 1">
        <button type="button" class="pg-arrow" @click="changePage(currentPage - 1)" :disabled="currentPage <= 1">
            &larr;
        </button>

        <button type="button" v-for="page in totalPages" :key="page" :class="{ active: page === currentPage }"
            @click="changePage(page)">
            {{ page }}
        </button>

        <button type="button" class="pg-arrow" @click="changePage(currentPage + 1)"
            :disabled="currentPage >= totalPages">
            &rarr;
        </button>
    </div>
</template>

<script>
export default {
    props: {
        // Contains pagination meta data like total_pages
        meta: {
            required: true,
            type: Object,
            // Basic validation for expected keys
            validator: (value) => typeof value.total_pages === 'number'
        },
        // Bound using v-model in the parent component, contains filters including 'page'
        modelValue: {
            required: true,
            type: Object,
            // Basic validation for expected keys
            validator: (value) => typeof value.page !== 'undefined' // Ensure page exists
        },
    },
    // Declare the event emitted for v-model updates
    emits: ['update:modelValue'],

    computed: {
        // Use modelValue directly to access the filters object
        filters() {
            return this.modelValue;
        },
        // Get the current page number safely, defaulting to 1
        currentPage() {
            // Ensure it's treated as a number
            return Number(this.filters.page) || 1;
        },
        // Get the total number of pages safely, defaulting to 0
        totalPages() {
            return Number(this.meta.total_pages) || 0;
        }
    },

    methods: {
        /**
         * Changes the current page if the new page number is valid.
         * Emits an update event for the v-model binding.
         * @param {number} pageNumber - The target page number.
         */
        changePage(pageNumber) {
            // Check if the target page is within valid bounds and is different from the current page
            if (
                pageNumber >= 1 &&
                pageNumber <= this.totalPages &&
                pageNumber !== this.currentPage
            ) {
                // Create a *new* filters object to avoid directly mutating the prop
                // and ensure reactivity works correctly with v-model
                const newFilters = {
                    ...this.filters, // Copy all existing filter properties
                    page: pageNumber // Update the page property
                };
                // Emit the 'update:modelValue' event with the new filters object
                this.$emit('update:modelValue', newFilters);
            }
        }
    }
}
</script>